/** Tracks whether the mentor has dismissed the one-time training welcome modal. */
export const WELCOME_STORAGE_KEY = "training-simulator:welcome:v1";
